exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ZTQe{display:block;margin-bottom:5px;max-width:100%;font-weight:700;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}textarea._2mVZx{height:200px}.n6CxX{padding:0 0 10px}.RAhsr{margin:10px 0}._3ehDL,.RAhsr{display:-webkit-box;display:-ms-flexbox;display:flex}._3ehDL{margin-right:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"label": "_2ZTQe",
	"textArea": "_2mVZx",
	"formComponent": "n6CxX",
	"errorMessage": "RAhsr",
	"alertIcon": "_3ehDL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/FormComponent/FormComponent.css
// module id = 915
// module chunks = 0 2 3 4 5 7 9 10 11